import { ThemeInput } from './types'

function toCssVarName (key: string) {
  // camelCase -> --color-camel-case
  return `--color-${key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}`
}

export function applyTheme (vars: ThemeInput) {
  const root = document.documentElement
  Object.entries(vars).forEach(([ key, value ]) => {
    if (!value) return
    const cssVar = toCssVarName(key)
    root.style.setProperty(cssVar, value)
  })
}
